import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from './plugins/axios-instance'
import VueAxios from 'vue-axios'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css';
import './assets/scss/va-element-plus-theme.css';
//import locale from 'element-plus/lib/locale/lang/en';

//used to set common interceptors for all ajax requests and responses
import interceptorsSetup from './backend/helpers/interceptors';
interceptorsSetup(router);
createApp(App)
    .use(router)
    .use(store)
    .use(ElementPlus, { size: 'default', zIndex: 3000 })
    .mount("#application");
